export const FEATURE_FLAGS = {
  SCHEDULING_3_FU_ROLLOUT: 'SCHEDULING_3_FU_ROLLOUT_10092024',
  DASHBOARD_3_ROLLOUT: 'DASHBOARD_3_ROLLOUT_15102024',
  INSTANT_SSE: 'INSTANT_SSE',
  PATIENT_APP_REVIEWS_ROLLOUT: 'PATIENT_APP_REVIEWS_ROLLOUT',
  SEXUAL_AWARENESS_WEEK: 'SEXUAL_AWARENESS_WEEK',
  DIAGNOSIS_EXPERIMENT: 'DIAGNOSIS_EXPERIMENT',
  SINGLE_PAGE_ADDRESS_COLLECTION: 'SINGLE_PAGE_ADDRESS_COLLECTION',
};
